import React, { createContext, useState, useContext } from 'react';
import { Snackbar, Alert } from '@mui/material';

export const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
  // message will be an object: { text: string, severity: 'error'|'success'|'info'|'warning' }
  const [message, setMessage] = useState(null);

  /**
   * showMessage displays a notification with the given text and severity.
   * Defaults to 'error' if severity is not provided.
   */
  const showMessage = (text, severity = 'error') => {
    setMessage({ text, severity });

    // Automatically hide after 5 seconds
    setTimeout(() => setMessage(null), 5000);
  };

  const handleClose = () => {
    setMessage(null);
  };

  return (
    <MessageContext.Provider value={{ message, showMessage }}>
      {children}

      {/* Our new Snackbar for displaying messages */}
      <Snackbar
        open={Boolean(message)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={5000}
        sx={{
          top: '60px !important', 
        }}
      >
        {message && (
          <Alert
            variant="filled"
            severity={message.severity}
            onClose={handleClose}
            sx={{ width: '100%' }}
          >
            {message.text}
          </Alert>
        )}
      </Snackbar>
    </MessageContext.Provider>
  );
};

export const useMessage = () => useContext(MessageContext);
